import { notification } from "../utils/local-antd";
import { AxiosError, isAxiosError } from "axios";

import i18n from "../i18n";

export class AtiraToast {
  static autoClose = 5;
  static style: React.CSSProperties = {};
  static theme = "colored";
  private static toastMap: Map<string, number> = new Map();

  private static getPlacement() {
    return i18n.language === "ar" ? "topLeft" : "topRight";
  }

  static success(message: string, config: any = {}) {
    const toastKey = "success";
    if (!this.toastMap.has(toastKey)) {
      notification.success({
        message: i18n.t("common.success"),
        description: message,
        duration: this.autoClose,
        style: this.style,
        placement: this.getPlacement(),
        onClose: () => this.toastMap.delete(toastKey),
        ...config,
      });
    }
  }

  static info(message: string, config: any = {}) {
    const toastKey = "info";
    if (!this.toastMap.has(toastKey)) {
      notification.info({
        message: i18n.t("common.info"),
        description: message,
        duration: this.autoClose,
        style: this.style,
        placement: this.getPlacement(),
        onClose: () => this.toastMap.delete(toastKey),
        ...config,
      });
    }
  }

  static warning(message: string, config: any = {}) {
    const toastKey = "warning";
    if (!this.toastMap.has(toastKey)) {
      notification.warning({
        message: i18n.t("common.warning"),
        description: message,
        duration: this.autoClose,
        style: this.style,
        placement: this.getPlacement(),
        onClose: () => this.toastMap.delete(toastKey),
        ...config,
      });
    }
  }

  static error(message: string) {
    const toastKey = "error";
    if (!this.toastMap.has(toastKey)) {
      notification.error({
        message: i18n.t("common.error"),
        description: message,
        duration: this.autoClose,
        style: this.style,
        placement: this.getPlacement(),
        onClose: () => this.toastMap.delete(toastKey),
      });
    }
  }

  static apiError(e: any, config: any = {}) {
    let message = "";
    let params = {};

    if (isAxiosError(e)) {
      if (typeof (e as AxiosError).response?.data === "string") {
        message = (e as AxiosError).response?.data as string;
      } else if (typeof (e as any).response?.data?.message === "string") {
        message = (e as any).response?.data?.message;
        params = (e as any).response?.data?.fields?.[0]?.params || {};
      } else {
        message = (e as AxiosError).message;
      }
    } else if (typeof e.message === "string") {
      message = e.message;
    }

    const toastKey = "apiError";
    if (!this.toastMap.has(toastKey)) {
      notification.error({
        message: i18n.t("common.error"),
        description: i18n.exists(message) ? i18n.t(message, params) : message,
        duration: this.autoClose,
        style: this.style,
        placement: this.getPlacement(),
        onClose: () => this.toastMap.delete(toastKey),
        ...config,
      });
    }
  }
}
